import PeopleAltOutlinedIcon from '@mui/icons-material/PeopleAltOutlined';
import HomeWorkOutlinedIcon from '@mui/icons-material/HomeWorkOutlined';
import KeyOutlinedIcon from '@mui/icons-material/KeyOutlined';
import ApartmentRoundedIcon from '@mui/icons-material/ApartmentRounded';
import CalculateOutlinedIcon from '@mui/icons-material/CalculateOutlined';
import ArticleOutlinedIcon from '@mui/icons-material/ArticleOutlined';

/*
 * Portal menüsü — Navbar (masaüstü) ve Sidebar (mobil çekmece) aynı listeyi kullanır.
 * Etiketler: portal.nav.<key>. İlanlar sayfası /ilanlar (sekme ?tab=homes | roommates).
 */

export const LISTINGS_PATH = '/ilanlar';
export const listingsPath = (tab) => `${LISTINGS_PATH}?tab=${tab === 'roommates' ? 'roommates' : 'homes'}`;

export const PORTAL_NAV = [
  { key: 'roommates', to: listingsPath('roommates'), Icon: PeopleAltOutlinedIcon },
  { key: 'listings', to: listingsPath('homes'), Icon: HomeWorkOutlinedIcon },
  { key: 'propertyTracking', to: '/mulk-takibi', Icon: KeyOutlinedIcon },
  { key: 'agencies', to: '/emlak-crm', Icon: ApartmentRoundedIcon },
  { key: 'tools', to: '/araclar', Icon: CalculateOutlinedIcon },
  { key: 'blog', to: '/blog', Icon: ArticleOutlinedIcon },
];

const under = (pathname, base) => pathname === base || pathname.startsWith(`${base}/`);

/** Menü öğesi geçerli sayfada mı? (location: react-router useLocation() sonucu) */
export const isPortalNavActive = (key, { pathname, search }) => {
  const tab = new URLSearchParams(search).get('tab');
  switch (key) {
    case 'roommates':
      return (pathname === LISTINGS_PATH && tab === 'roommates') || under(pathname, '/roommate-detail');
    case 'listings':
      return (
        (pathname === LISTINGS_PATH && tab !== 'roommates') ||
        under(pathname, '/advertisements') ||
        under(pathname, '/advertisement')
      );
    case 'propertyTracking':
      return under(pathname, '/mulk-takibi');
    case 'agencies':
      return pathname === '/emlak-crm';
    case 'tools':
      return under(pathname, '/araclar');
    case 'blog':
      return under(pathname, '/blog');
    default:
      return false;
  }
};
